/**
 * Parses a generic AIA template NetCDF file and returns times with TIC data.
 * @param reader - NetCDF reader instance
 * @returns Parsed times and series data
 */
export function aiaTemplate(reader) {
    const tic = reader.getDataVariable('ordinate_values');
    const delayTime = Number(reader.getDataVariable('actual_delay_time'));
    const interval = Number(reader.getDataVariable('actual_sampling_interval'));
    const time = new Array(tic.length);
    for (let i = 0; i < tic.length; i++) {
        time[i] = delayTime + i * interval;
    }
    return {
        times: time,
        series: [
            {
                name: 'tic',
                dimension: 1,
                data: tic,
            },
        ],
    };
}
//# sourceMappingURL=aiaTemplate.js.map